import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { API, useAuth } from "../App";
import axios from "axios";
import { Loader2, Shield } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const AuthCallback = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL fragment
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        console.error("No session_id found in URL");
        navigate("/auth", { replace: true });
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        // Exchange session_id for user data via backend
        const response = await axios.post(
          `${API}/auth/google/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        const { token, user } = response.data;

        // Store token and user in auth context
        login(token, user);

        // Clear the URL hash and navigate to dashboard
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true, state: { user } });
      } catch (error) {
        console.error("Auth callback error:", error);
        navigate("/auth", { 
          replace: true, 
          state: { error: "Erreur de connexion Google. Veuillez réessayer." } 
        });
      }
    };

    processAuth();
  }, [navigate, login]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FFF5F7] to-[#FFF0F5] flex flex-col items-center justify-center">
      <div className="flex items-center gap-2 mb-8">
        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-pink-200 to-pink-100 flex items-center justify-center shadow-lg">
          <Shield size={28} className="text-[#FF3366]" fill="#FF3366" />
        </div>
        <span className="text-3xl font-extrabold text-slate-900" style={{ fontFamily: 'Outfit' }}>
          SHARE
        </span>
      </div>
      <div className="text-center">
        <Loader2 className="animate-spin text-[#FF3366] mx-auto mb-4" size={48} />
        <p className="text-slate-600">Connexion en cours...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
